
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../../common/controllers/screencontrollerbase.ts" />
/// <reference path="../../common/controllers/app.common.controllers.module.ts" />
/// <reference path="app.hilo.controllers.module.ts" />
/// <reference path="../../common/controllers/documentuploadcontroller.ts" />

module App.HiLO.Controllers {
    import DocumentUploadConfig = App.Common.DocumentUploadConfig;
    import ModalDialogConfig = App.Common.ModalDialogConfig;
    'use strict';

    class SupportingDocumentUploadController extends App.Common.Controllers.DocumentUploadController<Hca.HiLO.ViewModel.ISupportingDocumentViewModel> {
       
        public busyPromise: angular.IPromise<any>;
        public static $inject = [
            '$injector',
            '$uibModalInstance',
            'config',
            'modalConfig',
            '$uibModalStack'
        ];

        constructor(
            $injector: angular.auto.IInjectorService,
            $uibModalInstance: angular.ui.bootstrap.IModalServiceInstance,
            public config: DocumentUploadConfig<Hca.HiLO.ViewModel.ISupportingDocumentViewModel>,
            modalConfig: ModalDialogConfig,
            $uibModalStack: angular.ui.bootstrap.IModalStackService) {
            super($injector, $uibModalInstance, config, modalConfig, $uibModalStack);
        }


        public initialize(): angular.IPromise<any> {
            return this.$q.resolve(); 
        }

    }


    angular
        .module('app.hilo.controllers')
        .controller('app.hilo.controllers.supportingDocumentUploadController', SupportingDocumentUploadController);

}